<template>
    <ProfileModal ref="profileModal"/>
    <OrganizationModal ref="organizationModalRef" :modalId="'navbarOrganizationModal'" v-if="currentRoute != 'organizations'"/>

    <div v-if="screensLoaded" class="lativoNavbar" :class="{ 'lativoNavbar--submenu-open': hoveredIndex !== null }">
        <header>
            <button class="hamburgerButton">
                <i :class="'bi bi-list'" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample"></i>
            </button>

            <img class="logo" src="../../images/LativoLogoWhite.png" @click="GoToHome"/>

            <nav class="navbar__nav">
                <div v-for="(screen, index) in screens" :key="screen.PKScreen" class="navbar__slot">
                    <!-- Leaf tab -->
                    <button v-if="screen.Children.length == 0"
                        class="navbar-item navbar-item-desktop"
                        :class="{ 'is-active': isScreenActive(screen) }"
                        @click="Redirect(screen.Route, index)">
                        <span class="navbar-item__label">{{ screen.DisplayName }}</span>
                        <span class="navbar-item__indicator" :class="{ 'is-active': isScreenActive(screen) }"></span>
                    </button>

                    <!-- Parent tab with fly-out submenu -->
                    <div v-else class="navbarDropdown"
                        @mouseenter="setDropdownHovered(index)"
                        @mouseleave="clearDropdownHovered(index, $event)">
                        <button
                            class="navbar-item navbar-item-desktop"
                            type="button"
                            :class="{ 'is-active': isScreenActive(screen), 'is-open': hoveredIndex === index }"
                            :aria-expanded="hoveredIndex === index ? 'true' : 'false'"
                            @click="setDropdownHovered(hoveredIndex === index ? null : index)">
                            <span class="navbar-item__label">{{ screen.DisplayName }}</span>
                            <i class="bi bi-chevron-down navbar-item__caret"></i>
                            <span class="navbar-item__indicator" :class="{ 'is-active': isScreenActive(screen) }"></span>
                        </button>

                        <transition name="submenu">
                            <ul v-show="hoveredIndex === index"
                                class="dropdown-menu navbar__submenu"
                                aria-labelledby="dropdownMenuButton">

                                <li v-for="(child) in screen.Children" :key="child.PKScreen">
                                    <a class="dropdown-item"
                                        :class="{ 'is-active': child.Route === currentRoute }"
                                        @click="Redirect(child.Route, index)">{{ child.DisplayName }}</a>
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>
            </nav>

            <div class="navbar__actions">
                <div v-if="assistantEnabled && store.Actions.USE_ASSISTANT" class="dropdown assistant">
                    <button class="userButton assistantButton" @click="ToggleAiAssistant(true)">
                        <img src="../../images/BotIcon.png" height="18" width="18"/>
                    </button>
                </div>
                <NotificationsMenu/>
                <ProfileMenu/>
            </div>

        </header>

        <div class="offcanvas offcanvas-start lativoOffcanva" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">

            <div class="returnButton" data-bs-dismiss="offcanvas" aria-label="Close" ref="btnCloseOffcanva">
                <i class="bi bi-arrow-left"></i>
            </div>

            <div class="offcanvas-body">
                <div class="lativoOffcanva__itemList">

                    <div v-for="(screen, index) in screens" :key="screen.PKScreen" class="navbarItemWrapper">
                        <button v-if="screen.Children.length == 0" class="navbar-item mobile"
                            :class="{ 'is-active': isScreenActive(screen) }"
                            @click="Redirect(screen.Route)">
                            {{ screen.DisplayName }}
                        </button>

                        <div v-else class="childNavbarItemWrapper">
                            <button class="navbar-item mobile childNavbarItem"
                                :class="{ 'is-active': isScreenActive(screen) }"
                                @click="screen.showChilds = !screen.showChilds" >
                                <label>{{ screen.DisplayName }}</label>

                                <i class="bi bi-chevron-down childCaret" :class="{ 'is-open': screen.showChilds }"></i>
                            </button>

                            <div class="childsWrapper" :class="{ shown: screen.showChilds == true }">
                                <div class="childsWrapper__clip">
                                    <button v-for="(child) in screen.Children" :key="child.name" class="navbar-item mobile childItem"
                                        :class="{ 'is-active': child.Route === currentRoute }"
                                        @click="Redirect(child.Route, index)">
                                        {{ child.DisplayName }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="assistantWrapper">
        <vue-draggable-resizable
            v-if="assistantEnabled && store.Actions.USE_ASSISTANT"
            :key="assistantKey"
            ref="aiAssistant"
            :parent="!store.isMobile"
            :drag-handle="'.header'"
            :z="999"
            :x="x"
            :y="y"
            :min-width="300"
            :min-height="300"
            :w="width"
            :h="height"
            :active="true"
            :hidden="!showAiAssistant"
        >
            <AiAssistant/>
        </vue-draggable-resizable>
    </div>
</template>

<script>
import { useStore } from '@/store/DefaultStore.js';
import { useRouter } from 'vue-router';
import NotificationsMenu from './NotificationsMenu.vue';
import { getAuth } from 'firebase/auth';
import ProfileMenu from '../Profile/ProfileMenu.vue';
import ProfileModal from '../Profile/ProfileModal.vue';
import OrganizationModal from '@/components/Views/Organizations/OrganizationModal.vue';
import vueDraggableResizable from 'vue-draggable-resizable';
import AiAssistant from '@/components/AI-Assistant/AiAssistant.vue';
import EventBus from '@/utilities/EventBus';
import { useSessionStore } from '@/store/SessionStore';

export default{
    name: 'NavBar',
    components: {
        NotificationsMenu, ProfileMenu, ProfileModal, OrganizationModal, vueDraggableResizable, AiAssistant
    },

    setup(){
        const store = useStore();
        const router = useRouter();
        const auth = getAuth();
        const sessionStore = useSessionStore();

        return{
            store, router, auth, sessionStore
        }
    },

    data(){
        return {
            screens: [],
            screensLoaded: false,
            assistantEnabled: false,
            hoveredIndex: null,
            currentRoute: '',
            aiAssistantObserver: null,
            showAiAssistant: false,
            assistantKey: 0,
            x: 0,
            y: 0,
            width: 300,
            height: 300,
            dropdownCloseTimeout: null,
            safeTriangleMoveHandler: null
        }
    },

    watch: {
        $route(to){
            this.currentRoute = to.name;
        }
    },

    beforeMount() {
        this.ResetAssistant();
    },

    mounted(){
        this.currentRoute = this.$route?.name ?? '';

        EventBus.$on('AssistantEnabledSettingUpdated', this.GetAssistantIsEnabled);
        EventBus.$on('RedirectToLogin', this.RedirectToLogin);
        EventBus.$on('SetScreens', this.SetScreens);
    },

    beforeUnmount(){
        EventBus.$off('AssistantEnabledSettingUpdated', this.GetAssistantIsEnabled);
        EventBus.$off('RedirectToLogin', this.RedirectToLogin);
        EventBus.$off('SetScreens', this.SetScreens);

        this.cancelSafeTriangle();
    },

    methods:{
        async RedirectToLogin() {
            this.store.LoggedUser = null;
            this.router.push({ name: 'login' });
        },

        SetScreens(screens) {
            this.screens = screens;
            this.screensLoaded = true;
        },

        GetAssistantIsEnabled(AssistantEnabled) {
            this.assistantEnabled = AssistantEnabled;
        },

        ResetAssistant(){
            this.width = this.store.isMobile ? 300 : 400;
            this.height = this.store.isMobile ? 400 : 600;
            this.x = this.store.isMobile ? 0 : 25;
            this.y = this.store.isMobile ? 0 : 25;
            this.assistantKey++;
        },

        ToggleAiAssistant(value = !this.showAiAssistant){
            this.showAiAssistant = value;
            this.defaultWidth = 600;
        },

        GoToHome(){
            if(this.store.isCustomer)
                this.router.push({ name: 'files' })
            else
                this.router.push({ name: 'home' });
        },

        UpdateOrganization()
        {
            this.$refs.organizationModalRef.OpenModal(this.store.CurrentOrganizationPK, true);
        },

        OpenProfileModal(){
            this.$refs.profileModal.OpenModal();
        },

        LogoClickHandler(){
            if(this.store.isCustomer)
                this.router.push({ name: 'files' })
            else
                this.router.push({ name: 'home' });
        },

        Redirect(route, index){
            this.store.currentPanel = index
            this.router.push({ name: route });

            if(this.$refs.btnCloseOffcanva){
                this.$refs.btnCloseOffcanva.click();
            }

            this.setHovered(null);
        },

        setHovered(index) {
            this.hoveredIndex = index;
        },

        // A tab is active when the live route matches its own route, or — for a
        // parent tab — the route of any of its sub-pages.
        isScreenActive(screen) {
            if (!screen) return false;
            if (screen.Route && screen.Route === this.currentRoute) return true;
            if (screen.Children && screen.Children.length) {
                return screen.Children.some(child => child.Route === this.currentRoute);
            }
            return false;
        },

        setDropdownHovered(index) {
            this.cancelSafeTriangle();
            this.hoveredIndex = index;
        },

        clearDropdownHovered(index, event) {
            this.cancelSafeTriangle();

            const wrapper = event && event.currentTarget;
            const menu = wrapper && wrapper.querySelector('.dropdown-menu');

            if (!menu || menu.offsetParent === null) {
                this.hoveredIndex = null;
                return;
            }

            const menuRect = menu.getBoundingClientRect();
            const apex = { x: event.clientX, y: event.clientY };
            const base1 = { x: menuRect.left, y: menuRect.top };
            const base2 = { x: menuRect.right, y: menuRect.top };

            this.safeTriangleMoveHandler = (e) => {
                const p = { x: e.clientX, y: e.clientY };
                if (this.pointInTriangle(p, apex, base1, base2)) return;
                this.cancelSafeTriangle();
                if (this.hoveredIndex === index) this.hoveredIndex = null;
            };
            document.addEventListener('mousemove', this.safeTriangleMoveHandler);

            this.dropdownCloseTimeout = setTimeout(() => {
                this.cancelSafeTriangle();
                if (this.hoveredIndex === index) this.hoveredIndex = null;
            }, 500);
        },

        cancelSafeTriangle() {
            if (this.dropdownCloseTimeout) {
                clearTimeout(this.dropdownCloseTimeout);
                this.dropdownCloseTimeout = null;
            }
            if (this.safeTriangleMoveHandler) {
                document.removeEventListener('mousemove', this.safeTriangleMoveHandler);
                this.safeTriangleMoveHandler = null;
            }
        },

        pointInTriangle(p, a, b, c) {
            const sign = (p1, p2, p3) =>
                (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
            const d1 = sign(p, a, b);
            const d2 = sign(p, b, c);
            const d3 = sign(p, c, a);
            const hasNeg = d1 < 0 || d2 < 0 || d3 < 0;
            const hasPos = d1 > 0 || d2 > 0 || d3 > 0;
            return !(hasNeg && hasPos);
        },
    }
}
</script>

<style>
/* Desktop */
@media (min-width: 1200px){
    .hamburgerButton {
        display: none;
    }

    .logo {
        margin-left: 20px;
    }

    /* TODO: verify usage — .logo img targets no element in this template (.logo is the img itself) */
    .logo img {
        max-width: 140px;
        height: 20px;
    }

    .navbar-item.mobile {
        display: none;
    }

    .navbar-item-desktop {
        display: inline-flex;
        margin-left: 30px;
    }
}

/* Compact desktop */
@media (min-width: 1050px) and (max-width: 1200px){
    .navbar-item-desktop {
        margin-left: 4px;
        padding: 0 10px;
    }

    .hamburgerButton {
        display: none;
    }

    .logo {
        margin-left: 20px;
    }

    .navbar__actions {
        padding-right: 10px;
    }
}

/* Mobile */
@media (max-width: 1050px){
    .logo {
        top: 50%; transform: translate(60px, 0); margin: 0px; width: auto;
    }

    .navbar-item-desktop {
        display: none;
    }

    .childNavbarItemWrapper {
        display: flex;
        width: 100%;
        /* !important beats the broad `.offcanvas-body div { padding: 20px }` rule,
           which otherwise indents the group item 20px past the leaf items. */
        padding: 0 !important;
        touch-action: manipulation;
    }

    .childNavbarItemWrapper button {
        width: 100%;
    }

    .childNavbarItem {
        padding-left: 10px;
    }

    .childNavbarItem i {
        margin-left: 10px;
    }

    .navbarItemWrapper {
        padding-left: 0px;
        padding-right: 0px;
    }
}

.navbar__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 16px;
}

/* Narrow mobile */
@media (max-width: 400px){
    .navbar__actions {
        gap: 0px;
    }
}

.assistantWrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999 !important;
    width: 100%;
    height: 100vh;
    pointer-events: none;
}

.lativoOffcanva .offcanvas-body div {
    display: flex;
    flex-direction: column;
    padding: 20px;
    font-size: 20px;
}

.lativoOffcanva .lativoOffcanva__itemList {
    padding-top: 0;
}

/* ---------- Mobile submenu accordion (animate) ----------
   grid-template-rows 0fr → 1fr smoothly animates to the children's natural
   height without a magic max-height. The clip child carries overflow:hidden.
   !important overrides the offcanvas-body `div{}` blanket rules. */
.childsWrapper {
    display: grid !important;
    grid-template-rows: 0fr;
    width: 100%;
    padding: 0 !important;
    transition: grid-template-rows 300ms var(--nav-ease-out);
}

.childsWrapper.shown {
    grid-template-rows: 1fr;
}

.childsWrapper__clip {
    overflow: hidden;
    min-height: 0;
    padding: 0 !important;
    display: flex !important;
    flex-direction: column;
    /* Fade the children in alongside the height reveal. */
    opacity: 0.35;
    transition: opacity 220ms ease;
}

.childsWrapper.shown .childsWrapper__clip {
    opacity: 1;
}

/* Sub-pages sit indented so the hierarchy reads at a glance. */
.childItem {
    padding-left: 26px !important;
    font-size: 16px !important;
}

/* Single caret that rotates on open, instead of swapping icon glyphs. */
.childCaret {
    font-size: 12px;
    transition: transform 240ms var(--nav-ease-out);
}

.childCaret.is-open {
    transform: rotate(180deg);
}

/* ---------- Parent tab fly-out submenu (req 5) ---------- */
/* Absolutely positioned panel hanging off the bottom of the parent tab: the
   rest of the main menu stays visible and interactive. The safe-triangle
   (JS) keeps it open while the pointer travels from parent to children. */
.navbar__nav .navbar__submenu {
    display: block;
    position: absolute;
    top: calc(100% - 6px);
    left: 12px;
    min-width: 208px;
    margin: 0;
    padding: 6px;
    list-style: none;
    background-color: var(--LativoDarkPurple);
    font-family: 'SwitzerMedium', sans-serif;
    border: 1px solid rgba(222, 228, 255, 0.10);
    border-radius: 12px;
    box-shadow: 0 20px 44px -18px rgba(9, 9, 14, 0.7), 0 2px 8px -4px rgba(9, 9, 14, 0.5);
    /* Grow from the parent tab, not from its own centre. */
    transform-origin: top left;
    z-index: 5;
}

.navbar__submenu > li {
    list-style: none;
}

.navbar__nav .dropdown-item {
    display: flex;
    align-items: center;
    height: 38px;
    padding: 0 12px;
    border-radius: 8px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 14px;
    cursor: pointer;
    transition: background-color 150ms ease, color 150ms ease;
}

.navbar__nav .dropdown-item:hover {
    background-color: var(--nav-hover-surface);
    color: #ffffff;
}

/* Active sub-page reads as lavender, tied by a short accent tick on the left. */
.navbar__nav .dropdown-item.is-active {
    color: var(--nav-accent);
    background-color: rgba(222, 228, 255, 0.08);
}

.navbar__nav .dropdown-item.is-active::before {
    content: "";
    width: 3px;
    height: 16px;
    margin-right: 9px;
    margin-left: -3px;
    border-radius: 2px;
    background-color: var(--nav-accent);
}

/* ---------- Submenu enter / exit (animate) ---------- */
.submenu-enter-active {
    transition: opacity 180ms var(--nav-ease-out), transform 180ms var(--nav-ease-out);
}

.submenu-leave-active {
    transition: opacity 130ms ease, transform 130ms ease;
}

.submenu-enter-from,
.submenu-leave-to {
    opacity: 0;
    transform: translateY(-6px) scale(0.97);
}

.lativoNavbar {
    /* Local motion + accent tokens, mirroring the redesigned login world:
       raisin bar, lavender as the signature accent. */
    --nav-accent: var(--LativoLightPurple);
    --nav-ink-dim: rgba(255, 255, 255, 0.62);
    /* Shared rest tone for every action-cluster icon (glyphs + the bot PNG). */
    --nav-icon-rest: rgba(255, 255, 255, 0.85);
    --nav-hover-surface: rgba(222, 228, 255, 0.10);
    --nav-ease-out: cubic-bezier(0.23, 1, 0.32, 1);

    position: sticky;
    top: 0px;
    z-index: 996 !important;
}

/* While a parent tab's fly-out submenu is open, lift the whole navbar above the
   teleported floating menus (Multiselect / DatePicker sit at z-index 2000), so
   the submenu options paint on top of them. Scoped to the open state on purpose:
   a static value >2000 would poke the sticky bar over a BaseModal overlay
   (also z-index 2000). A navbar dropdown is never open while a modal is up (its
   backdrop blocks the bar), so the elevation is safe here. */
.lativoNavbar--submenu-open {
    z-index: 2001 !important;
}

.lativoNavbar header {
    background-color: var(--LativoDarkPurple);
    color: white;
    width: 100%;
    height: 60px;
    display: flex;
    position: sticky;
    top: 0px;
    align-items: center;
    /* Req 3 — the bar reads as a lifted plane over the lavender-tinted app. */
    box-shadow: 0 10px 26px -14px rgba(31, 31, 44, 0.55), 0 1px 0 rgba(31, 31, 44, 0.12);
}

/* Main-menu row (leaf + parent tabs), full-height so the selected-tab strip
   can pin to the very bottom of the bar. */
.navbar__nav {
    display: flex;
    align-items: stretch;
    height: 100%;
}

.navbar__slot,
.navbar__nav .navbarDropdown {
    display: flex;
    align-items: stretch;
    height: 100%;
}

/* Anchor point for the absolutely positioned fly-out submenu. */
.navbar__nav .navbarDropdown {
    position: relative;
}

/* TODO: verify usage — .logo img targets no element in this template (.logo is the img itself) */
.logo img {
    max-width: 140px;
    margin: 0px;
}

.logo {
    height: 20px;
    cursor: pointer;
    padding: 0px;
}

.hamburgerButton {
    background-color: transparent;
    border: none;
    position: absolute;
    left: 0px;
    margin-left: 10px;
    transition: transform 120ms var(--nav-ease-out);
}

.hamburgerButton:active {
    transform: scale(0.9);
}

.hamburgerButton i {
    color: rgb(245, 245, 245);
    font-size: 30px !important;
}

.lativoOffcanva {
    background-color: transparent;
    border: none !important;
    width: 100% !important;
}

.lativoOffcanva .returnButton {
    color: white;
    position: absolute !important;
    top: 15px !important;
    left: 15px !important;
    padding-top: 0px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    transition: background-color 160ms ease, transform 120ms var(--nav-ease-out);
    -webkit-tap-highlight-color: transparent;
}

.lativoOffcanva .returnButton:active {
    transform: scale(0.92);
    background-color: var(--nav-hover-surface);
}

@media (hover: hover) and (pointer: fine) {
    .lativoOffcanva .returnButton:hover {
        background-color: var(--nav-hover-surface);
    }
}

.lativoOffcanva .returnButton i {
    font-size: 24px;
    margin-right: 0;
}

.lativoOffcanva .offcanvas-body {
    background-color: rgb(31, 31, 44, 0.9);
    color: white;
}

.lativoOffcanva div {
    padding-top: 80px;
}

.navbar-item {
    position: relative;
    align-items: center;
    gap: 6px;
    height: 60px;
    padding: 0 14px;
    background-color: transparent;
    font-family: 'SwitzerMedium', sans-serif;
    font-size: 14px;
    border: none;
    color: var(--nav-ink-dim);
    cursor: pointer;
    transition: color 160ms ease;
    /* Buttons default to text-align:center; on wrapped (2-line) labels this
       centered each line instead of keeping them flush left. */
    text-align: left;
}

.navbar-item .navbar-item__label {
    position: relative;
    z-index: 1;
}

/* Soft lavender wash behind the hovered / open tab. Its own layer so the
   selection strip and label stay crisp above it. */
.navbar-item::before {
    content: "";
    position: absolute;
    inset: 10px 0px;
    border-radius: 10px;
    opacity: 0;
    transform: scale(0.96);
    transition: opacity 160ms ease, transform 200ms var(--nav-ease-out);
    pointer-events: none;
}

.navbar-item.is-active {
    color: #ffffff;
}

/* An open parent keeps the wash even when the pointer is over its submenu. */
.navbar-item.is-open {
    color: #ffffff;
}

.navbar-item.is-open::before {
    opacity: 1;
    transform: scale(1);
}

.navbar-item__caret {
    font-size: 11px;
    margin: 0;
    transition: transform 200ms var(--nav-ease-out);
}

.navbar-item.is-open .navbar-item__caret {
    transform: rotate(180deg);
}

/* Req 4 — the thin lavender strip pinned to the bottom of the bar, marking
   the selected screen. Grows in from the tab's centre. */
.navbar-item__indicator {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 0;
    height: 2.5px;
    border-radius: 3px 3px 0 0;
    background-color: var(--nav-accent);
    box-shadow: 0 0 10px rgba(222, 228, 255, 0.55);
    transform: scaleX(0);
    transform-origin: center;
    opacity: 0;
    transition: transform 240ms var(--nav-ease-out), opacity 200ms ease;
}

.navbar-item__indicator.is-active {
    transform: scaleX(1);
    opacity: 1;
}

@media (hover: hover) and (pointer: fine) {
    .navbar-item:hover {
        color: #ffffff;
    }

    .navbar-item:hover::before {
        opacity: 1;
        transform: scale(1);
    }

    /* Faint preview strip on hover of a tab that isn't the active one. */
    .navbar-item:hover .navbar-item__indicator:not(.is-active) {
        transform: scaleX(0.55);
        opacity: 0.45;
    }
}

.navbar-item:active::before {
    transform: scale(0.97);
}

.navbar-item.mobile {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    /* Grow with wrapped labels instead of clamping to the base .navbar-item
       height:60px — that clamp made long names overflow into the next item. */
    height: auto;
    min-height: 48px;
    line-height: 1.3;
    margin-left: 0px !important;
    font-size: 18px !important;
    margin-bottom: 6px !important;
    padding: 12px 14px;
    border-radius: 12px;
    /* Tap feedback + surface; kill the blue mobile tap flash. */
    transition: background-color 160ms ease, transform 120ms var(--nav-ease-out);
    -webkit-tap-highlight-color: transparent;
}

/* Parent toggle: label left, caret pinned to the right edge. */
.childNavbarItem {
    justify-content: space-between;
}

.navbar-item.mobile:active {
    transform: scale(0.98);
    background-color: var(--nav-hover-surface);
}

@media (hover: hover) and (pointer: fine) {
    .navbar-item.mobile:hover {
        background-color: var(--nav-hover-surface);
    }
}

.userButton {
    background-color: transparent;
    border: none;
    color: white;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    min-width: 40px;
    height: 40px;
    padding: 0 8px;
    border-radius: 12px;
    position: relative;
    /* Subtle wash-in + press feedback; motion tokens inherit from .lativoNavbar. */
    transition: background-color 160ms ease, transform 140ms var(--nav-ease-out);
}

/* Every action icon rests at one shared light tone; hover/open lifts to pure white. */
.userButton i {
    color: var(--nav-icon-rest);
    transition: color 160ms ease;
}

/* The bot PNG is pure white, so match it to the glyphs' rest tone via opacity. */
.userButton.assistantButton img {
    opacity: 0.85;
    transition: opacity 160ms ease;
}

/* Instant feedback: the button scales down the moment it's pressed. */
.userButton:active {
    transform: scale(0.94);
}

.userButton:focus-visible {
    outline: 2px solid var(--nav-accent);
    outline-offset: 2px;
}

/* An open dropdown keeps the lavender wash + bright icon, tying trigger to panel. */
.userButton[aria-expanded="true"] {
    background-color: var(--nav-hover-surface);
}

.userButton[aria-expanded="true"] i {
    color: #ffffff;
}

.userButton[aria-expanded="true"].assistantButton img,
.userButton.assistantButton:active img {
    opacity: 1;
}

/* TODO: verify usage — not referenced in this template; may be used by child components */
.userButton.mobile {
    border-radius: 50%;
    width: 40px;
}

@media (hover: hover) and (pointer: fine) {
    .userButton:hover {
        background-color: var(--nav-hover-surface);
    }

    .userButton:hover i {
        color: #ffffff;
    }

    .userButton.assistantButton:hover img {
        opacity: 1;
    }
}

.userButton img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
}

.userButton.assistantButton img {
    height: 18px;
    width: 18px;
    border-radius: 0;
    margin-right: 0px;
}

.userButton i {
    font-size: 18px;
}

.userButton.mobile i {
    /* TODO: verify !important — possible conflict with external styles */
    margin-right: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.userButtonMenu {
    cursor: pointer;
    background-color: var(--LativoDarkPurple);
    color: white;
    padding-left: 15px;
    padding-right: 15px;
    box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.2);
}

.userButtonMenu:hover {
    background-color: rgb(62, 62, 62);
}

/* ---------- Mobile (offcanvas) active state ---------- */
.navbar-item.mobile.is-active {
    color: var(--LativoLightPurple) !important;
    position: relative;
}

.navbar-item.mobile.is-active::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    border-radius: 3px;
    background-color: var(--LativoLightPurple);
}

/* ---------- Reduced motion ---------- */
@media (prefers-reduced-motion: reduce) {
    .navbar-item__indicator {
        transition: opacity 160ms ease;
        transform: scaleX(1);
    }

    .navbar-item::before,
    .navbar-item__caret {
        transition: opacity 160ms ease;
    }

    .submenu-enter-active,
    .submenu-leave-active {
        transition: opacity 140ms ease;
    }

    .submenu-enter-from,
    .submenu-leave-to {
        transform: none;
    }

    .userButton {
        transition: background-color 160ms ease;
    }

    .userButton:active {
        transform: none;
    }

    /* Keep the accordion (still snappy) but drop caret + press motion. */
    .childCaret {
        transition: none;
    }

    .navbar-item.mobile:active,
    .hamburgerButton:active,
    .lativoOffcanva .returnButton:active {
        transform: none;
    }
}
</style>
